import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  className = '',
  fullWidth = false
}: ButtonProps) {
  return <motion.a href="http://impulsodigital.vip/cart/44844060049494:1" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative inline-flex items-center justify-center gap-2 text-center
        bg-brand-yellow text-black font-display text-base sm:text-xl md:text-2xl 
        py-4 px-6 sm:px-8 rounded-lg uppercase tracking-wide leading-tight
        shadow-[0_0_30px_rgba(255,193,7,0.4)] hover:shadow-[0_0_40px_rgba(255,193,7,0.6)]
        transition-shadow duration-300
        ${fullWidth ? 'w-full' : 'max-w-full'}
        ${className}
      `} data-id="element-55">
      <span className="relative z-10" data-id="element-56">{children}</span>
      <ChevronRight className="w-5 h-5 md:w-8 md:h-8 relative z-10 shrink-0" strokeWidth={3} data-id="element-57" />
      <div className="absolute inset-0 bg-white/20 rounded-lg opacity-0 hover:opacity-100 transition-opacity duration-300" data-id="element-58" />
    </motion.a>;
}